<ng-container *ngFor="let w of widgets" axf-widget-renderer [widget]="w" [mode]="'print'" [parent]="this">
</ng-container>